module.exports = __webpack_public_path__ + "img/53067949.639aac10.png";